module.exports = __webpack_public_path__ + "static/images/clock-green.a84cb2c266ae0fdedaffe339f8a77f59.svg";